<div class="users-container">
  <cc-panel-with-links [displayInfoPanel]="hasInfoPanel" [displayTabsPanel]="true">
    <div *ngIf="hasInfoPanel" infoPanel class="info-panel">
      <h5 class="info-panel-title">{{ learnHowToUseTitle }}:</h5>
      <div class="info-links">
        <a
          *ngFor="let learnMoreItem of sitemateLearnMoreLinks"
          class="link-no-formatting"
          [href]="learnMoreItem.url"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="info-item">
            <span class="learn-more-title">{{ i18NTitles[learnMoreItem.titleCode] }}</span>
            <i class="cc-icon cc-icon-link-view sm-self-center sm-pl-2"></i>
          </div>
        </a>
      </div>
    </div>

    <div tabsPanel>
      <span class="tab-title">
        <img
          src="assets/icons/multi-colored-icons/dashpivot-square.svg"
          alt="dashpivot-logo"
          class="sm-mr-1"
        />
        <h3 i18n>Dashpivot Users</h3>
      </span>
      <cc-panel-with-links-tabs class="mb-4" [panelTabs]="dashpivotListTabs"></cc-panel-with-links-tabs>
      <span class="tab-title">
        <img src="assets/icons/multi-colored-icons/sitemate-square.svg" alt="sitemate-logo" class="sm-mr-1" />
        <h3 i18n>Sitemate Users</h3>
      </span>
      <cc-panel-with-links-tabs [panelTabs]="sitemateListTabs"></cc-panel-with-links-tabs>
    </div>
  </cc-panel-with-links>
</div>
